import { z } from 'zod';

import {
  imageQuery,
  imageSchema,
  MediaItemSizeEnum,
} from '~/lib/api/fragments/image';

interface VideoQueryOptions {
  thumbnailSize?: MediaItemSizeEnum;
}

export const videoQuery = ({
  thumbnailSize = 'MEDIUM',
}: VideoQueryOptions = {}) => /* graphql */ `
  node {
    id
    mimeType
    title
    altText
    mediaItemUrl
    mediaDetails {
      width
      height
    }

    featuredImage {
      ${imageQuery(thumbnailSize)}
    }
  }
`;

export const videoSchema = z.object({
  node: z.object({
    id: z.string(),
    mimeType: z.string(),
    title: z.string(),
    altText: z.string(),
    mediaItemUrl: z.string(),
    mediaDetails: z.object({
      width: z.number(),
      height: z.number(),
    }),

    featuredImage: imageSchema.nullish(),
  }),
});

export type VideoSchema = z.infer<typeof videoSchema>;
